<proffeo-ui-dialog [title]="'project-locations.modals.add-location-modal-title' | translate">
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex w-full gap-2 flex-col">
      <proffeo-ui-input
        [formField]="form.name"
        label="project-locations.modals.form-label-name"
      />
    </div>
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="form().invalid() || form().submitting()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
